var _g, _path, _g2, _g3, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 76,
    viewBox: "0 0 79 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6554_16708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6412 54.485C51.8796 54.485 62.6115 43.7531 62.6115 30.5147C62.6115 17.2763 51.8796 6.54443 38.6412 6.54443C25.4027 6.54443 14.6709 17.2763 14.6709 30.5147C14.6709 43.7531 25.4027 54.485 38.6412 54.485Z",
    fill: "url(#paint0_radial_6554_16708)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.9873 7.17857C16.9873 6.60079 17.1446 6.04667 17.4246 5.6381C17.7045 5.22954 18.0842 5 18.4802 5H37.8869C38.2829 5 38.6626 5.22954 38.9425 5.6381C39.2224 6.04667 39.3797 6.60079 39.3797 7.17857C39.3797 7.75635 39.2224 8.3105 38.9425 8.71906C38.6626 9.12763 38.2829 9.35714 37.8869 9.35714H18.4802C18.0842 9.35714 17.7045 9.12763 17.4246 8.71906C17.1446 8.3105 16.9873 7.75635 16.9873 7.17857ZM16.9873 63.8214C16.9873 63.2436 17.1446 62.6894 17.4246 62.2809C17.7045 61.8724 18.0842 61.6429 18.4802 61.6429H37.8869C38.2829 61.6429 38.6626 61.8724 38.9425 62.2809C39.2224 62.6894 39.3797 63.2436 39.3797 63.8214C39.3797 64.3993 39.2224 64.9532 38.9425 65.3619C38.6626 65.7704 38.2829 66 37.8869 66H18.4802C18.0842 66 17.7045 65.7704 17.4246 65.3619C17.1446 64.9532 16.9873 64.3993 16.9873 63.8214Z",
    fill: "#3F75E0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6554_16708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3136 45.1519H57.1389L52.7412 49.4383L54.9238 51.7493L57.3136 45.1519ZM63.4135 60.7384C63.6982 61.0506 64.0389 61.2996 64.4157 61.471C64.7923 61.6422 65.1974 61.7324 65.6073 61.7364C66.0172 61.74 66.4236 61.6574 66.8031 61.493C67.1824 61.3286 67.5273 61.0858 67.8171 60.779C68.1069 60.4722 68.3362 60.107 68.4914 59.7054C68.6467 59.3036 68.7248 58.8732 68.7213 58.4392C68.7176 58.0052 68.6323 57.5763 68.4707 57.1775C68.3087 56.7785 68.0736 56.4178 67.7787 56.1164L63.4135 60.7384ZM54.9238 51.7493L63.4135 60.7384L67.7787 56.1164L57.3136 45.1519L54.9238 51.7493Z",
    fill: "url(#paint1_radial_6554_16708)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3803 54.3114C36.138 54.6419 32.8625 54.237 29.7982 53.1266C26.7338 52.0162 23.9595 50.2288 21.6814 47.8979H8.94362C8.367 47.8979 7.81403 48.127 7.40631 48.5347C6.9986 48.9423 6.76956 49.4953 6.76953 50.072V54.4201C6.76953 54.9968 6.9986 55.5498 7.40631 55.9575C7.81403 56.3651 8.367 56.5942 8.94362 56.5942H37.2063C37.7829 56.5942 38.336 56.3651 38.7436 55.9575C39.1512 55.5498 39.3803 54.9968 39.3803 54.4201V54.3114Z",
    fill: "#3F75E0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.527 40.5189H34.8519C35.4385 40.5189 36.001 40.2545 36.4156 39.784C36.8303 39.3131 37.0633 38.6751 37.0633 38.0094V32.9905C37.0633 32.3248 36.8303 31.6865 36.4156 31.2159C36.001 30.7454 35.4385 30.481 34.8519 30.481H17.1609C17.1609 34.1373 18.0233 37.5653 19.527 40.5189ZM16.9134 40.5189C15.6959 37.3529 14.6667 33.9353 14.6709 30.481H2.21142C1.6249 30.481 1.06243 30.7454 0.647716 31.2159C0.232997 31.6865 2.76424e-05 32.3248 0 32.9905V38.0094C0 38.6751 0.232997 39.3131 0.647716 39.784C1.06243 40.2545 1.6249 40.5189 2.21142 40.5189H16.9134Z",
    fill: "#D9E3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1632 23.5318H35.0555C35.5881 23.5318 36.0987 23.308 36.4752 22.9099C36.8516 22.5115 37.0631 21.9716 37.0631 21.4084V17.1615C37.0631 16.5983 36.8516 16.0582 36.4752 15.66C36.0987 15.2618 35.5881 15.0381 35.0555 15.0381H27.2741C24.056 16.9274 21.5479 19.9246 20.1632 23.5318ZM15.8991 23.5318C16.8493 20.3382 18.5004 17.4277 20.7173 15.0381H8.95684C8.42438 15.0381 7.91374 15.2618 7.53724 15.66C7.16074 16.0582 6.94924 16.5983 6.94922 17.1615V21.4084C6.94922 21.9716 7.16074 22.5115 7.53724 22.9099C7.91374 23.308 8.42438 23.5318 8.95684 23.5318H15.8991Z",
    fill: "#3F75E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6554_16708",
    x: 4.6709,
    y: 0.544434,
    width: 67.9404,
    height: 67.9404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6554_16708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6554_16708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6554_16708",
    x: 42.7412,
    y: 39.1519,
    width: 35.9805,
    height: 36.5845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6554_16708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6554_16708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6554_16708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5148 78.4553) rotate(-85.6466) scale(238.051 267.707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B02C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EDFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6554_16708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.3558 70.0288) rotate(-85.8047) scale(82.3348 89.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B02C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.b85560ecf596dde5113645666a261f2b.svg";
export { ForwardRef as ReactComponent };